.container {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  width: 32rem;
  min-width: 32rem;
  max-width: 32rem;
  height: 100%;
  scroll-snap-align: start;
  background-color: var(--color-surface-secondary);
  border-radius: var(--card-border-radius);
  transition: box-shadow 0.2s ease;

  &[data-drop-target='true'] {
    box-shadow: inset 0 0 0 0.1rem var(--color-surface-further);
  }
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  padding: 1rem 1.2rem;
}

.header-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
}

.name {
  font-size: 1.4rem;
  font-weight: 500;
  color: var(--color-texts-high-contrast);
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.count {
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--color-texts-low-contrast);
  user-select: none;
  margin-inline-start: 0.4rem;
}

.list {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 8rem;
  overflow-y: auto;
  padding: 0 0.8rem 0.8rem;
}
